import styled from 'styled-components'

export const Root = styled.div`
  display: grid;
  margin: ${props => props.margin};
  width: 100%;
`
